import {MODEL_FIELD_DISPLAY_NAME} from 'instruments/equipment/EquipmentConstants';
import {RequiredLink, SchemaField} from 'schemas/fields/SchemaFieldConstants';

/**
 * Get required link from a tag schema's Model schema field. Primarily used for tag schemas with equipment SSI
 */
export default function getModelRequiredLinkFromTagSchema(tagSchema: {
  allFields: Array<SchemaField>;
}): RequiredLink | null {
  const modelField = tagSchema.allFields.find((field) => field.name === MODEL_FIELD_DISPLAY_NAME);
  return modelField?.requiredLink ?? null;
}
